import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { validateTransportTest } from "@config/config";
import { MasterNetService } from "./samcanet.service";
import {
  buildCheckTransportNumberArgs,
  fakeTransportSuccess,
} from "@app/utils/utils";
import { BaseService } from "./base.service";
import { AppConfigService } from "@master/core/dist/core";

@Injectable({
  providedIn: "root",
})
export class ValidateTransportService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService,
    private masterNetService: MasterNetService
  ) {
    super(appConfigService)
  }



  validateTransport(
    formData: any,
    matriculas: string,
    configTransport: any,
    packet?: any
  ): Observable<any> {
    // Validar transporte
    return this.checkTransportNumber(
      formData,
      matriculas,
      configTransport,
      packet
    );
  }

  validateMasterNet(
    nTransporte: string,
    nTransportista: string
  ): Observable<any> {
    return this.masterNetService.acceptedPrevision(nTransporte, nTransportista);
  }

  checkTransportNumber(
    formData,
    matriculas,
    configTransport,
    packet?: any
  ): Observable<any> {

    if (validateTransportTest) {
      const simulatedObservable = of(fakeTransportSuccess);
      return simulatedObservable;
    }
    const args = buildCheckTransportNumberArgs(
      formData,
      matriculas,
      configTransport,
      packet
    );
    console.log(args);
    const url = this.getUrl() + '/ws-samca/validate-transport-data';
    return this.http.post(
      url,
      { ...args },
      {
        headers: new HttpHeaders().set("Content-Type", "application/json"),
      }
    );
  }
}
